import { Stack } from '@chakra-ui/react';
import { Empty } from '@halo/ui-chat-react';
import type { Dispatch, SetStateAction } from 'react';
import { isEmpty } from 'lodash/fp';
import { ResultsGroups } from './ResultsByGroup';
import { ExtraElement } from './ResultContacts';
import type { SearchTabs, SearchResults } from './helpers';

interface ResultGroupsProps {
  searchValue: string;
  searchResults: SearchResults;
  setActive: Dispatch<SetStateAction<SearchTabs>>;
}

const ResultGroups = ({ searchResults, searchValue, setActive }: ResultGroupsProps) => {
  const { groupsData, globalGroupsData } = searchResults;

  if (isEmpty(groupsData) && isEmpty(globalGroupsData))
    return (
      <Stack className="fadeIn" gap="2">
        <Empty className="fadeIn" />
        <ExtraElement searchValue={searchValue} setActive={setActive} mt="10" />
      </Stack>
    );

  return (
    <Stack className="fadeIn" gap="2">
      <ResultsGroups searchResults={searchResults} />
      <ExtraElement searchValue={searchValue} setActive={setActive} />
    </Stack>
  );
};

const MemoResultGroups = memo(ResultGroups);

export { MemoResultGroups as ResultGroups };
